export const MAX_PERSISTED_CANDLES = 5_000;
